module.exports = __webpack_public_path__ + "img/game-paused.197d54c1.png";